import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const AddCustomerToLoanModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  customer, onCustomerChange, customerError, setCustomerError, filteredCustomerList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add customer'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='customer' label='Add customer'
      value={customer} onChange={onCustomerChange} optionList={filteredCustomerList}
      error={customerError} setError={setCustomerError}
    />
  </ModalFormUI>

export default AddCustomerToLoanModalUI
